import React from 'react';
import SkeletonComponent from './SkeletonComponent.jsx';
import 'react-loading-skeleton/dist/skeleton.css';

const DynamicSkeletonGrid = ({ rowSizes, colSizes, gap = '1rem', margin = 0, width = '100%', height = '100%' }) => {
  const format = value => (typeof value === 'number' ? `${value}px` : value);
  const gapValue = typeof gap === 'number' ? `${gap}px` : gap;

  const rows = rowSizes && rowSizes.length
    ? rowSizes.map(format).join(' ')
    : `repeat(auto-fill, minmax(0, 1fr))`;
  const cols = colSizes && colSizes.length
    ? colSizes.map(format).join(' ')
    : `repeat(auto-fill, minmax(0, 1fr))`;

  const totalCells = (rowSizes?.length || 1) * (colSizes?.length || 1);

  return (
    <div
      style={{
        display: 'grid',
        width: width,
        height: height,
        margin: margin,
        gridTemplateRows: rows,
        gridTemplateColumns: cols,
        gap: gapValue,
      }}
    >
      {Array.from({ length: totalCells }).map((_, idx) => (
        <SkeletonComponent key={idx} width="100%" height="100%" />
      ))}
    </div>
  );
};

export default DynamicSkeletonGrid;
